export default "__VITE_ASSET__cE30uG48__"